export default [
  {
    path: '',
    name: 'cotizaciones',
    component: () => import(/* webpackChunkName: "cotizaciones" */ '@/apps/cotizaciones/pages/CotizacionesPage.vue')
  }
]
